@let isEmbedded = store.isEmbeddedSg();
@let hasData = store.pluginSg()?.feature?.selectors?.hasData?.asSignal();
@let isLoading =
  store
    .ecSg()
    ?.plugins?.currentListPlugin?.feature?.selectors?.isLoading?.asSignal();
@let containerHeight = containerHeightSg();

<div
  class="atn-ds-table-data"
  #tableContainer
  [class.atn-ds-table--embedded]="isEmbedded"
  [style.height]="containerHeight"
  (mouseleave)="store.setHoveredRow(undefined)"
>
  <div
    class="atn-ds-table-data__content-wrapper"
    (mouseenter)="store.setHoveredRow(undefined)"
    (scroll)="onTableScrollHandler($event)"
  >
    <div
      class="atn-ds-table-data__content"
      (mouseenter)="store.setHoveredRow(undefined)"
    >
      @if (hasData && !isLoading) {
        <table-column-headers />
        <div class="atn-ds-table-data__body">
          <table-rows />
        </div>
      } @else {
        <table-empty-state />
      }
    </div>
  </div>
</div>
